import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import lodashCompact from 'lodash/fp/compact';

import momentWithAustinTimezone from 'common/util/momentWithAustinTimezone';

import {
  formatPrice,
} from 'common/formatters';

import {
  DATA_TABLE_SOURCE_PARTNER_LISTING_HISTORICAL_UPDATES,
} from 'common/dataTableConstants';

import SrDataTableConnected from 'client/components/SrDataTableConnected';
import SrDataTableUI from 'client/components/SrDataTableUI';

const SrDataTablePartnerListingHistoricalUpdates = ({
  listing,
}) => {
  return (
    <SrDataTableConnected
      itemsPropName='updates'
      rootViewId='all'
      dataSource={DATA_TABLE_SOURCE_PARTNER_LISTING_HISTORICAL_UPDATES}
      initialViewSettings={{
        sort: {
          createdDate: 'desc',
        },
        filter: {
          listingId: listing.id,
        },
      }}
    >
      {({ updates, viewSettings, onInfiniteScrollWrapperRef }) => {
        return (
          <div ref={onInfiniteScrollWrapperRef}>
            <SrDataTableUI
              dataTableViewSettings={viewSettings}
              headers={[
                {
                  content: 'date/time',
                },
                {
                  content: 'price',
                },
                {
                  content: 'cdom',
                },
                {
                  content: 'change',
                },
              ]}
              rows={updates.map((update) => {
                const cdom = listing.firstActiveDate
                  ? momentWithAustinTimezone(update.createdDate).diff(listing.firstActiveDate, 'days')
                  : -1;

                return {
                  cells: [
                    {
                      content: moment(update.createdDate).format('MM/DD/YYYY H:mm A'),
                    },
                    {
                      content: update.price
                        ? formatPrice(update.price)
                        : '--',
                    },
                    {
                      content: cdom >= 0
                        ? cdom
                        : '--',
                    },
                    {
                      content: update.field === 'price'
                        ? [
                          formatPrice(parseFloat(update.fromValue)),
                          formatPrice(parseFloat(update.toValue)),
                        ].join(' → ')
                        : lodashCompact([
                          update.fromValue,
                          update.toValue,
                        ]).join(' → '),
                    },
                  ],
                };
              })}
            />
          </div>
        );
      }}
    </SrDataTableConnected>
  );
};

SrDataTablePartnerListingHistoricalUpdates.propTypes = {
  listing: PropTypes.object.isRequired,
};

SrDataTablePartnerListingHistoricalUpdates.displayName = 'SrDataTablePartnerListingHistoricalUpdates';

export default SrDataTablePartnerListingHistoricalUpdates;
